import React from "react";
import clsx from "clsx";

import "../clients/Tools/kit/tools-page-header.css";
import "./build-page.css";
import "./build-conversation.css";
import "./playbook-build-panel.css";
import "./build-page-skeleton.css";

class BuildPageSkeleton extends React.PureComponent {
	render() {
		const { hasPanelTabs } = this.props;
		const headerClassName = clsx("tools-page-header", "tools-page-header--compact", hasPanelTabs && "tools-page-header--with-nav");
		const sideClassName = clsx("build-page__side", hasPanelTabs && "playbook-build-panel");
		const cards = (
			<>
				<div className="build-card tk-card build-page-skeleton__card">
					<span className="build-page-skeleton__block build-page-skeleton__card-title" />
					<span className="build-page-skeleton__block build-page-skeleton__line" />
					<span className="build-page-skeleton__block build-page-skeleton__line build-page-skeleton__line--short" />
				</div>
				<div className="build-card tk-card build-page-skeleton__card">
					<span className="build-page-skeleton__block build-page-skeleton__card-title" />
					<span className="build-page-skeleton__block build-page-skeleton__line" />
					<span className="build-page-skeleton__block build-page-skeleton__line" />
					<span className="build-page-skeleton__block build-page-skeleton__line build-page-skeleton__line--short" />
				</div>
			</>
		);

		return (
			<div className="build-page build-page-skeleton" aria-busy="true">
				<span className="build-page-skeleton__hidden-label">Loading the conversation</span>
				<header className={headerClassName} aria-hidden="true">
					<div className="tools-page-header__row">
						<span className="build-page-skeleton__block build-page-skeleton__back" />
						<span className="build-page-skeleton__block build-page-skeleton__icon" />
						<div className="tools-page-header__text">
							<span className="build-page-skeleton__block build-page-skeleton__title" />
							<span className="build-page-skeleton__block build-page-skeleton__facts" />
						</div>
						<span className="build-page-skeleton__block build-page-skeleton__button" />
					</div>
					{hasPanelTabs && (
						<div className="tools-page-header__nav build-page-skeleton__stages">
							{[0, 1, 2, 3].map(stage => (
								<span key={stage} className="build-page-skeleton__block build-page-skeleton__stage" />
							))}
						</div>
					)}
				</header>
				<div className="build-page__layout" aria-hidden="true">
					<section className="build-conversation tk-card">
						<div className="build-conversation__messages">
							<div className="build-conversation__message build-conversation__message--guide build-page-skeleton__message">
								<span className="build-page-skeleton__block build-page-skeleton__avatar" />
								<span className="build-page-skeleton__block build-page-skeleton__bubble build-page-skeleton__bubble--long" />
							</div>
							<div className="build-conversation__message build-conversation__message--person build-page-skeleton__message">
								<span className="build-page-skeleton__block build-page-skeleton__bubble build-page-skeleton__bubble--person" />
							</div>
							<div className="build-conversation__message build-conversation__message--guide build-page-skeleton__message">
								<span className="build-page-skeleton__block build-page-skeleton__avatar" />
								<span className="build-page-skeleton__block build-page-skeleton__bubble build-page-skeleton__bubble--medium" />
							</div>
						</div>
						<div className="build-conversation__composer">
							<span className="build-page-skeleton__block build-page-skeleton__input" />
							<div className="build-conversation__composer-actions">
								<span className="build-page-skeleton__block build-page-skeleton__link" />
								<span className="build-page-skeleton__block build-page-skeleton__send" />
							</div>
						</div>
					</section>
					<div className={sideClassName}>
						{hasPanelTabs && (
							<>
								<div className="tk-tabs build-page-skeleton__tabs">
									{[0, 1, 2, 3].map(tab => (
										<span key={tab} className="build-page-skeleton__tab">
											<span className="build-page-skeleton__block build-page-skeleton__tab-label" />
										</span>
									))}
								</div>
								<div className="playbook-build-panel__pane">{cards}</div>
							</>
						)}
						{!hasPanelTabs && cards}
					</div>
				</div>
			</div>
		);
	}
}

export default BuildPageSkeleton;
